import React, { useEffect, useRef } from "react";

/**
 * Plain-HTML gear cursor + lagging trail (no SVG at all, deliberately —
 * see GearsBackground.js for the SVG transform-attribute/CSS-animation
 * interaction bug this sidesteps entirely by not using SVG here).
 * Position is written straight to element styles via refs on every animation
 * frame (not React state) to avoid a re-render per mousemove.
 */
function CursorGear() {
  const headRef = useRef(null);
  const trailRefs = useRef([]);

  useEffect(() => {
    const isFinePointer = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!isFinePointer || reduceMotion) return undefined;

    document.body.classList.add("gear-cursor-active");

    const mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const points = [
      { x: mouse.x, y: mouse.y },
      { x: mouse.x, y: mouse.y },
      { x: mouse.x, y: mouse.y },
    ];
    const lerpFactors = [0.35, 0.22, 0.15];

    const handleMove = (e) => {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    };
    window.addEventListener("mousemove", handleMove, { passive: true });

    let raf;
    const tick = () => {
      points[0].x += (mouse.x - points[0].x) * lerpFactors[0];
      points[0].y += (mouse.y - points[0].y) * lerpFactors[0];
      for (let i = 1; i < points.length; i++) {
        points[i].x += (points[i - 1].x - points[i].x) * lerpFactors[i];
        points[i].y += (points[i - 1].y - points[i].y) * lerpFactors[i];
      }

      if (headRef.current) {
        headRef.current.style.left = `${points[0].x}px`;
        headRef.current.style.top = `${points[0].y}px`;
      }
      trailRefs.current.forEach((el, i) => {
        const p = points[i + 1];
        if (el && p) {
          el.style.left = `${p.x}px`;
          el.style.top = `${p.y}px`;
        }
      });

      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", handleMove);
      cancelAnimationFrame(raf);
      document.body.classList.remove("gear-cursor-active");
    };
  }, []);

  return (
    <div className="cursor-gear-layer" aria-hidden="true">
      <span className="cursor-trail-dot cursor-trail-2" ref={(el) => (trailRefs.current[1] = el)} />
      <span className="cursor-trail-dot cursor-trail-1" ref={(el) => (trailRefs.current[0] = el)} />
      <span className="cursor-gear-head" ref={headRef}>
        <span className="cursor-gear-spin" />
      </span>
    </div>
  );
}

export default CursorGear;
